import { usePatientStore } from '@/stores/patientData/patientData.ts'

// Retrieves store if it's populated.
// If this the first time accessing the store (store is empty),
// then it makes the API call and updates/returns the store
export async function retrievePatientData() {
	const store = usePatientStore()

	if (!store.loaded) {
		// check if dependent or policyholder
		await store.loadPatientData()
	}

	return store
}
